import { connect } from 'react-redux';

import Header from './header';

const mapStateToProps = state => ({
  locale: state.app.pageData.languageSwitch,
  accessibilityIsOpen: state.accessibility.isOpen,
  navIsOpen: state.navigation.isOpen,
  searchIsOpen: state.search.isOpen
});

export default connect(mapStateToProps)(Header);
